import { createAction, props } from '@ngrx/store';
import {
  CONTACT_FILTER_TYPE,
  IContactApiProps,
  IContactForm,
  IGenericInteractionProps,
} from '../repositories/IContact.repository';
import { ContactInteractionModel, ContactModel } from '../models/contact.model';

export enum ContactsActionTypes {
  fetchContactBegin = '[Contacs] Fetch contact begin',
  fetchContactSuccess = '[Contacs] Fetch contact success',
  fetchContactFail = '[Contacs] Fetch contact failure',

  fetchInteractionsBegin = '[Contacs] Fetch Interactions begin',
  fetchInteractionsSuccess = '[Contacs] Fetch Interactions success',
  fetchInteractionsFail = '[Contacs] Fetch Interactions failure',

  createContactBegin = '[Contacs] Create begin',
  createContactSuccess = '[Contacs] Create success',
  createContactFail = '[Contacs] Create failure',

  deleteContactBegin = '[Contacs] Delete contact begin',
  deleteContactSuccess = '[Contacs] Delete contact success',
  deleteContactFail = '[Contacs] Delete contact failure',

  updateContactBegin = '[Contacs] Update contact begin',
  updateContactSuccess = '[Contacs] Update contact success',
  updateContactFail = '[Contacs] Update contact failure',

  importContactBegin = '[Contacs] Import contact begin',
  importContactSuccess = '[Contacs] Import contact success',
  importContactFail = '[Contacs] Import contact failure',

  filterContactsBegin = '[Contacs] Filter contact begin',
  filterContactsSuccess = '[Contacs] Filter contact success',
  filterContactsFail = '[Contacs] Filter contact failure',

  selectContact = '[Contacs] Select contact',

  createInteractionBegin = '[Contacs] Create Interacion Begin',
  createInteractionSuccess = '[Contacs] Create Interacion Success',
  createInteractionFail = '[Contacs] Create Interacion Fail',
}

// Fetch contacts from remote API
export const fetchContactBeginAction = createAction(
  ContactsActionTypes.fetchContactBegin
);

export const fetchContactSuccessAction = createAction(
  ContactsActionTypes.fetchContactSuccess,
  props<{ contacList: ContactModel[] }>()
);

export const fetchContactFailAction = createAction(
  ContactsActionTypes.fetchContactFail,
  props<{ errors: any }>()
);

export const fetchInteractionsBeginAction = createAction(
  ContactsActionTypes.fetchInteractionsBegin,
  props<{ contactId: number }>()
);

export const fetchInteractionsSuccessAction = createAction(
  ContactsActionTypes.fetchInteractionsSuccess,
  props<{ interactions: ContactInteractionModel[] }>()
);

export const fetchInteractionsFailAction = createAction(
  ContactsActionTypes.fetchInteractionsFail,
  props<{ errors: any }>()
);

// Create contacts
export const createContactBeginAction = createAction(
  ContactsActionTypes.createContactBegin,
  props<{ contactForm: IContactForm }>()
);

export const createContactSuccessAction = createAction(
  ContactsActionTypes.createContactSuccess,
  props<{ contacts: ContactModel[] }>()
);

export const createContactFailAction = createAction(
  ContactsActionTypes.createContactFail,
  props<{ errors: any }>()
);

// Delete contacts
export const deleteContactBeginAction = createAction(
  ContactsActionTypes.deleteContactBegin,
  props<{ contactId: number }>()
);

export const deleteContactSuccessAction = createAction(
  ContactsActionTypes.deleteContactSuccess,
  props<{ contactList: ContactModel[] }>()
);

export const deleteContactFailAction = createAction(
  ContactsActionTypes.deleteContactFail,
  props<{ errors: any }>()
);

// Update contacts
export const updateContactBeginAction = createAction(
  ContactsActionTypes.updateContactBegin,
  props<{ contactForm: IContactForm }>()
);

export const updateContactSuccessAction = createAction(
  ContactsActionTypes.updateContactSuccess,
  props<{ contactList: ContactModel[] }>()
);

export const updateContactFailAction = createAction(
  ContactsActionTypes.updateContactFail,
  props<{ errors: any }>()
);

// Import contacts
export const importContactBeginAction = createAction(
  ContactsActionTypes.importContactBegin,
  props<{ contactList: IContactApiProps[] }>()
);

export const importContactSuccessAction = createAction(
  ContactsActionTypes.importContactSuccess,
  props<{ contactList: ContactModel[] }>()
);

export const importContactFailAction = createAction(
  ContactsActionTypes.importContactFail,
  props<{ errors: any }>()
);

// FILTERING
export const filterContactsBeginAction = createAction(
  ContactsActionTypes.filterContactsBegin,
  props<{ clientType: CONTACT_FILTER_TYPE }>()
);

export const filterContactsSuccessAction = createAction(
  ContactsActionTypes.filterContactsSuccess,
  props<{ contactList: ContactModel[] }>()
);

export const filterContactsFailAction = createAction(
  ContactsActionTypes.filterContactsFail,
  props<{ errors: any }>()
);

export const selectContactAction = createAction(
  ContactsActionTypes.selectContact,
  props<{ contactId: number }>()
);

export const createInteractionBeginAction = createAction(
  ContactsActionTypes.createInteractionBegin,
  props<{ contactId: number; config: IGenericInteractionProps }>()
);

export const createInteractionSuccessAction = createAction(
  ContactsActionTypes.createInteractionSuccess,
  props<{ interactions: ContactInteractionModel[] }>()
);

export const createInteractionFailAction = createAction(
  ContactsActionTypes.createInteractionFail,
  props<{ errors: any }>()
);
